import React, { Component } from 'react';

function Director(props) {
  const img_src = `assets/img/director/${props.director.img}`;
  return (
    <div className="director clearfix">
      <div className="director-img">
        <img src={img_src} alt={props.director.name_ja}/>
      </div>
      <div className="director-profile">
        <div className='director-name-ja'>{props.director.name_ja}</div>
        <div className='director-name-en'>{props.director.name_en}</div>
        <div className='director-bio'>{props.director.bio}</div>
      </div>
    </div>
  )
}

export class DirectorList extends Component {
  render() {
    const directors = [
      {
        img: 'matsumura.jpg',
        name_ja: "松村 努",
        name_en: "Tsutomu Matsumura",
        bio: "東京藝術大学音楽学部声楽科卒業。声楽を三林輝夫、河瀬柳史、指揮を黒岩英臣、ヘルムート・リリンクの両氏に師事。現在、東京・神奈川県を中心とした多くの合唱団を指揮、指導。全日本合唱連盟副理事長。日本合唱指揮者協会会員。神奈川県合唱連盟顧問。一般社団法人 音楽樹理事。"
      },
      {
        img: 'saitoh.jpg',
        name_ja: "斎藤 三和子",
        name_en: "Miwako Saitoh",
        bio: "東京藝術大学音楽学部声楽科卒業、同大学院修士課程修了。日本音楽コンクール入選、奏楽堂日本歌曲コンクールにおいて奨励賞受賞。ヴォイストレーナー等で合唱とかかわるとともに、デビューリサイタル以降、宗教曲をはじめ同世代の作曲家による歌曲作品の初演や現代曲など、様々な分野でその独自の世界を表出展開させている。日本演奏連盟会員。"
      },
      {
        img: 'oda.jpg',
        name_ja: "織田 祥代",
        name_en: "Sachiyo Oda",
        bio: "東京藝術大学音楽学部附属音楽高等学校を経て、東京藝術大学音楽学部器楽科ピアノ専攻卒業。同大学院修士課程音楽研究科ピアノ専攻修了。これまでに、手塚敏子、坪田昭三、クラウス・シルデ、故ハリーナ・チェルニー・ステファンカの各氏に師事。「音楽家たちの饗宴、室内楽シリーズ」にて新日本フィルメンバーと協演。また、モーツァルト、J.S.バッハの協奏曲をオーケストラと協演。現在ソロ活動の他に、室内楽、声楽及び合唱の伴奏や合唱講習会等で幅広く演奏活動を行っている。"
      }
    ];

    const directorNodes = directors.map((director, i) => {
      return <Director director={director} key={i}/>

    });

    return (
      <div className="content">{directorNodes}</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DirectorList.jsx